import type { TFunction } from 'i18next';
import { formatCivilOrDash } from '@/i18n/format';

const RESELLER_ROLES = new Set(['OWNER', 'ADMIN', 'STAFF']);
const CUSTOMER_ROLES = new Set(['USER', 'GUEST']);
const INVITATION_STATUSES = new Set(['PENDING', 'ACCEPTED', 'REVOKED', 'EXPIRED']);

/** A role as a label — an unknown value shows as received. */
export function roleLabel(role: string | null, t: TFunction): string {
  if (!role) return t('members.none');
  if (RESELLER_ROLES.has(role)) return t(`roles.${role}`);
  if (CUSTOMER_ROLES.has(role)) return t(`members.role.${role}`);
  return role;
}

/** An invitation status (`PENDING | ACCEPTED | REVOKED | EXPIRED`) — unknown is "—". */
export function invitationStatusLabel(status: string, t: TFunction): string {
  return INVITATION_STATUSES.has(status)
    ? t(`members.invitationStatus.${status}`)
    : t('statements.unavailable');
}

/**
 * The calendar day of a saas-auth timestamp (a `LocalDateTime` or an ISO instant), as received —
 * no time-zone shift. Anything that does not start with `YYYY-MM-DD` shows as a dash.
 */
export function dayOf(value: string | null, locale: string, t: TFunction): string {
  return formatCivilOrDash(value, locale, t('members.none'));
}
